import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Grid from '@material-ui/core/Grid';
import liffHelper from '../utils/liffHelper';
import { Redirect } from 'react-router-dom'
import Noredi from '../pages/ProfileNativeCr'
import InputBase from '@material-ui/core/InputBase';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
// import InputLabel from '@material-ui/core/InputLabel';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
// import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
// import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
// import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper'
import ButtonBase from '@material-ui/core/ButtonBase';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: theme.spacing(3, 2)
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: 200,
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  }
}));

const BootstrapInput = withStyles(theme => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);



// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      profile: {
        pictureUrl: "https://cdn4.iconfinder.com/data/icons/men-avatars-icons-set-2/256/4-512.png",
        displayName: "DisplayName: LINENAME",
      },
      mongo: {
        Ck_Name: 'false'
      },
      redi: {
        redirect: false,
        redirectnogroup: false
      },
      datafrom: {
        brace: ''
      },
      Ck_NameF: 'FFFFF',
      Ck_NameL: '',
      stacheck: {
        stacheck2: false
      },
      collect: {
        collectq: false
      },
      password: this.props.location.state.password,
      showselect: false,
      showselectgrouptype: false,
      showselectbrance: false,
      namecus: 'name',
      typeCr: '',
      openW: false,
      openS: false,
      phone: false,
      Card: 'null',
      namegr: '',
      collectq: false,
      // collectq1: 'MsnRafco_Sender'
    };


  }
  async componentDidMount() {
    // if (this.props.location.state.groupId === "Ce4da4f72ef6b62ae7a591a15a7d8af50") {
      // const profile = await liffHelper.initcontext()
      const profile = await liffHelper.getProfile()
      // alert("Password")
      // alert(this.state.password)
      
      if(this.state.password == 'Rplc'){
        // alert(this.state.password)
        this.setState({
            collectq: 'MsnRPLC_Sender',
            collectgrouptype: 'GroupType_RPLC',
            collectBrance: 'brance_RPLC_rplc'
        })
      } else if(this.state.password == 'Rafco'){
        this.setState({
          collectq: 'MsnRafco_Sender',
          collectgrouptype: 'GroupType_Rafco',
          collectBrance: 'Brance'
      })
      }else if(this.state.password == 'Motor'){
        this.setState({
          collectq: 'MsnRafco_Sender',
          collectgrouptype: 'GroupType_RPLC',
          collectBrance: 'brance_RPLC_rplc'
      })
      }
      // // alert(this.state.collectq)
      this.setState({
        profile: {
          userId: profile.userId,
          groupId: profile.groupId,
          displayName: "CK,MK : " + this.props.location.state.Ck_NameF + " " + this.props.location.state.Ck_NameL,
          pictureUrl: profile.pictureUrl
        },
        // redi: {
        //   redirectnogroup: truemo
        // }
      });
      if(this.state.collectq != false){
        /**************customer**************** */
      const nna = await liffHelper.list(10, this.state.collectq)
      if (nna != undefined) {
        // alert(nna[0].Ck_NameF)
        this.setState({
          showselect: nna
        });
      }
       /**************grouptype**************** */
       const ana = await liffHelper.list(100, this.state.collectgrouptype)
       if (ana != undefined) {
        //  alert(ana[0])
         this.setState({
           showselectgrouptype: ana
         });
       }
       /**************Brance**************** */
       const bna = await liffHelper.list(100, this.state.collectBrance)
       if (bna != undefined) {
         // alert(nna[0].Ck_NameF)
         this.setState({
          showselectbrance: bna
         });
       }       
    }

    // } else {
    //   this.setState({
    //     redi: {
    //       redirectnogroup: true
    //     }
    //   });

    // }
  }

  renderRedirect = () => {

    // if (this.state.redi.redirectnogroup != false) {
    //   return <Redirect
    //     to={{
    //       pathname: '/CircularIndeterminate',
    //       state: { id: this.state.profile.displayName }
    //     }}
    //   />
    // }
    // if (this.state.home != undefined) {
    //   return <Redirect
    //     to={{
    //       pathname: '/'
    //     }}
    //   />
    // }
    // if (this.state.namegr != '') {
    //   this.setState({namegr: this.state.typeCr + ' ' + this.state.Fistname + ' ' + this.state.Lastname + ' ' + this.state.bracecus })
    // }

  }
  async SearchOther() {
    const nna = await liffHelper.list(5000, this.state.collectq)
    // alert(nna)
    if (nna != undefined) {
      // alert(nna[0].Ck_NameF)
      // alert(this.state.data)
      this.setState({
        showselect: nna
      });
      alert('Search Finish')


    }
  }
  async handleChange(event) {

    //  const monget = await liffHelper.mongget(event.target.name) 
    // alert(event.target.value)
    // alert(event.target.value[0])
    // alert(event.target.value[1])
    // let v1 = event.target.value[0]
    // const checkin = await liffHelper.checkin(v1)
    this.setState({ selected: event.target.value[0], namecus: event.target.value[1] });
    // alert(this.state.namecus)
  };

  async renderOptions() {

    const nna = await liffHelper.list(100, this.state.collectq)
    // alert('nna')
    if (nna != undefined) {
      // alert(nna[0].Ck_NameF)
      // alert(this.state.data)
      this.setState({
        showselect: nna
      });


    }
  }

  closeWindow() {
    liffHelper.closeWindow()
  }

  async creatG() {
    if (this.state.namecus == undefined) {
      alert('required namecus')
    }
    else if (this.props.location.state.Ck_NameF == '') {
      alert('required Ck_NameF')
    }
    else if (this.props.location.state.Ck_NameL == '') {
      alert('required Ck_NameL')
    }
    else if (this.state.selected == undefined) {
      alert('required selected')
    }
    else if (this.state.Fistname == undefined) {
      alert('required Fistname')
    }
    else if (this.state.Lastname == undefined) {
      alert('required Lastname')
    }
    // else if (this.state.Card == undefined) {
    //   alert('required Card')
    // }
    else if (this.state.phone == undefined || this.state.phone == false) {
      alert('required phone')
    }
    else if (this.state.bracecus == undefined) {
      alert('required bracecus')
    }
    else {
      this.setState({
        openW: true
      });
      // alert(this.state.Fistname)
      const cr = await liffHelper.creatG(this.state.namecus, this.props.location.state.Ck_NameF,
        this.props.location.state.Ck_NameL, this.state.selected, this.state.Fistname,
        this.state.Lastname, this.state.Card, this.state.phone, this.state.bracecus, this.state.namegr,
        this.props.location.state.Ck_Brance, this.props.location.state.idfb ,this.state.collectq)
      if (cr != undefined) {
        // alert(nna[0].Ck_NameF)
        // alert(cr.status)
        this.setState({
          dialog: cr.status,
          openW: false,
          openS: true
        });


      }


    }
  }
  ChangbanceSta(event) {
    // for(var i=0;i<2;i++){
    this.setState({ typeCr: event.target.value })
    // this.setState({ namegr: this.state.typeCr + '.  ' + this.state.Fistname + ' ' + this.state.Lastname + ' ' + this.state.bracecus })
    // alert(this.state.datafrom.brace)
  // }
}
Refresh(event) {
  // for(var i=0;i<2;i++){
  this.setState({ namegr: this.state.typeCr + '.  ' + this.state.Fistname + ' ' + this.state.Lastname + ' ' + this.state.bracecus })
  // alert(this.state.datafrom.brace)
// }
}

  render() {
    const classes = this.props;

    return (
      // <div className={classes.root}>
      // <div>
      //   <Noredi />

      <div className={classes.root} >
        <Noredi />
        {this.renderRedirect()}
        <Paper className={classes.paper} style={{ marginTop: 10, padding: 30 }}>
          <CssBaseline />
          <div className={classes.paper} >
            <Typography component="h1" variant="h5">
              CreatGroup Messenger
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="email"
                // label="Admin Messenger Rafco"
                label={this.state.profile.displayName}
                name="email"
                autoComplete="email"
                autoFocus
                disabled="disabled"
              />
              {
                (this.state.showselect != false)
                  ?
                  <FormControl className={classes.margin} >
                    <InputLabel shrink htmlFor="age-native-label-placeholder">Customer</InputLabel>
                    <Select className="width50" value={this.state.selected} onChange={this.handleChange.bind(this)}
                      input={<BootstrapInput />}
                      label="Select Branch"
                      labelWidth='50'
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                    >
                      {this.state.showselect.map((dt, i) => {
                        // alert(dt.Ck_NameF)
                        return (
                          <MenuItem
                            label="Select Customer"
                            // value={dt.MsnName}
                            value={[dt.ProfilePic, dt.MsnName]}
                            key={i} name={dt.MsnName}>{dt.MsnName}</MenuItem>

                        );
                      })}
                    </Select>
                    {/* <h3>Selected  - {this.state.selected}</h3> */}
                  </FormControl>
                  :
                  null
              }
              {/*   */}
              <Dialog
                open={this.state.openW}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{"please wait.."}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <CircularProgress />
                    <CircularProgress color="secondary" />
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  {/* <Button  color="primary">
                    Disagree
                  </Button>
                  <Button  color="primary" autoFocus>
                    Agree
                  </Button> */}
                </DialogActions>
              </Dialog>
              <Dialog
                open={this.state.openS}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                {/* <DialogTitle id="alert-dialog-title">{"please wait.."}</DialogTitle> */}
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    CreatGroup {this.state.dialog}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="primary" onClick={event => this.setState({ openS: false })}>
                    Retry
                  </Button>
                  <Button color="primary" autoFocus onClick={this.closeWindow.bind(this)}>
                    Agree
                  </Button>
                </DialogActions>
              </Dialog>
              {
                (this.state.namecus != "name")
                  ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="email"
                    // label="Admin Messenger Rafco"
                    label={"Name: " + this.state.namecus}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    disabled="disabled"
                  />
                  :
                  null
              }
              {
                (this.state.namecus != "name")
                  ?
                  <Grid container >
                    <Button variant="outlined" color="secondary" onClick={this.SearchOther.bind(this)}>
                      Search Other
              </Button>

                  </Grid>
                  :
                  null
              }
              {
                (this.state.namecus != "name")
                  ?
                  <Grid container spacing={2}>
                    <Grid item style={{ marginTop: 10, padding: 30 }}>

                      <ButtonBase className={classes.image}>

                        <img width="135" height="150" alt="complex" src={this.state.selected} />
                      </ButtonBase>
                    </Grid>
                  </Grid>
                  :
                  null
              }
              {/* {
                (this.state.namecus != "name")
                  ?
                  <FormControl className={classes.margin}>
                    <InputLabel shrink htmlFor="age-native-label-placeholder">Type Group</InputLabel>
                    <Select
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                      value={this.state.bracecus}
                      // :this.state.typeCr+' '+this.state.Fistname+' '+this.state.Lastname+' '+this.state.bracecus
                      onChange={this.ChangbanceSta.bind(this)}
                      // onChange={event => this.setState({ typeCr: event.target.value })}
                      input={<BootstrapInput />}
                      label="Select Type"
                      labelWidth='50'
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={"OC"}>OC</MenuItem>
                      <MenuItem value={"PC"}>PC</MenuItem>
                      <MenuItem value={"MC"}>MC</MenuItem>
                      <MenuItem value={"DC"}>DC</MenuItem>
                      <MenuItem value={"NC"}>NC</MenuItem>
                    </Select>
                  </FormControl>
                  :
                  null
              } */}
               {
                (this.state.showselectgrouptype != false && this.state.namecus != 'name')
                  ?
                  <FormControl className={classes.margin} >
                    <InputLabel shrink htmlFor="age-native-label-placeholder">Type Group</InputLabel>
                    <Select className="width50" value={this.state.typeCr} onChange={this.ChangbanceSta.bind(this)}
                      input={<BootstrapInput />}
                      label="Select Branch"
                      labelWidth='50'
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                    >
                      {this.state.showselectgrouptype.map((dt, i) => {
                        // alert(dt.Ck_NameF)
                        return (
                          <MenuItem
                            label="Select Customer"
                            // value={dt.MsnName}
                            value={dt.Grouptype}
                            key={i} name={dt.Grouptype}>{dt.Grouptype}</MenuItem>

                        );
                      })}
                    </Select>
                    {/* <h3>Selected  - {this.state.selected}</h3> */}
                  </FormControl>
                  :
                  null
              }

              {
                (this.state.namecus != "name")
                  ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Fistname"
                    name="Fistname"

                    autoFocus
                    onChange={event => this.setState({ Fistname: event.target.value })}
                  // disabled="disabled"
                  />
                  :
                  null
              }
              {
                (this.state.namecus != "name")
                  ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="Lastname"
                    name="Lastname"

                    autoFocus
                    onChange={event => this.setState({ Lastname: event.target.value})}
                  // disabled="disabled"
                  />
                  :
                  null
              }
              {
                (this.state.namecus === "-")
                  ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="ID Card No."
                    name="ID Card No."
                    autoComplete="ID Card No."
                    autoFocus
                    onChange={event => this.setState({ Card: event.target.value })}
                  // disabled="disabled"
                  />
                  :
                  null
              }
              {
                (this.state.namecus != "name")
                  ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label="phone number"
                    name="phone number"
                    autoComplete="phone number"
                    autoFocus
                    onChange={event => this.setState({ phone: event.target.value })}
                  // disabled="disabled"
                  />
                  :
                  null
              }
              {/* {
                (this.state.namecus != "name")
                  ?
                  <FormControl className={classes.margin}>
                    <InputLabel shrink htmlFor="age-native-label-placeholder">Branch</InputLabel>
                    <Select
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                      value={this.state.bracecus}
                      // onChange={this.Changbance.bind(this)}
                      onChange={event => this.setState({ bracecus: event.target.value})}
                      input={<BootstrapInput />}
                      label="Select Branch"
                      labelWidth='50'
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={"PNP"}>PNP</MenuItem>
                      <MenuItem value={"BTB"}>BTB</MenuItem>
                      {/* <MenuItem value={"MCM"}>MCM</MenuItem> */}
               {
                (this.state.showselectgrouptype != false && this.state.namecus != 'name' && this.state.typeCr != '')
                  ?
                  <FormControl className={classes.margin} >
                    <InputLabel shrink htmlFor="age-native-label-placeholder">Branch</InputLabel>
                    <Select className="width50" value={this.state.bracecus} onChange={event => this.setState({ bracecus: event.target.value})}
                      input={<BootstrapInput />}
                      label="Select Branch"
                      labelWidth='50'
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                    >
                      {this.state.showselectbrance.map((dt, i) => {
                        // alert(dt.Ck_NameF)
                        return (
                          <MenuItem
                            label="Select Customer"
                            // value={dt.MsnName}
                            value={dt.bracese}
                            key={i} name={dt.bracese}>{dt.bracese}</MenuItem>

                        );
                      })}
                    </Select>
                    {/* <h3>Selected  - {this.state.selected}</h3> */}
                  </FormControl>
                  :
                  null
              }
              {
                (this.state.namecus != "name")
                  ?
                  <Grid item xs={12} md={6}>
                    <Button size="large" variant="outlined" color="primary" onClick={this.Refresh.bind(this)} style={{ marginTop: 10 }}>
                      Refresh
                  </Button>
                  </Grid>
                  :
                  null
              }
              {
                (this.state.namecus != "name")
                  ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    label={this.state.namegr}
                    name="GroupName"
                    autoComplete="GroupName"
                    autoFocus
                    // onChange={event => this.setState({ GroupName: event.target.value })}
                    disabled="disabled"
                  />
                  :
                  null
              }
              {
                (this.state.namecus != "name")
                  ?
                  <Grid item xs={12} md={6}>
                    <Button size="large" variant="outlined" color="primary" onClick={this.creatG.bind(this)} style={{ marginTop: 10 }}>
                      SAVE
                  </Button>
                  </Grid>
                  :
                  null
              }
            </form>
          </div>
          <h1><br></br></h1><h1><br></br></h1><h1><br></br></h1><h1><br></br></h1><h1><br></br></h1>
        </Paper>

      </div>
    );
  }
}




// WEBPACK FOOTER //
// src/pages/CreatGroup_RPLC.js